import React from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import API from "../API";
import BusinessFormDialog from "../components/businesses/BusinessFormDialog";

const getErrorMessage = (response) => {
  if (response?.error === 3401 || response?.code === 3401) {
    return "Bu e-posta adresi zaten kullanılıyor.";
  }

  if (typeof response?.error === "string") return response.error;
  if (typeof response?.message === "string") return response.message;
  return "Bir şeyler ters gitti.";
};

export default class BusinessesScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      businesses: [],
      q: "",
      includeInactive: false,
      loading: true,
      saving: false,
      editDialogOpen: false,
      selectedBusiness: undefined,
    };
  }

  componentDidMount() {
    this.loadBusinesses();
  }

  loadBusinesses = async () => {
    this.setState({ loading: true });

    const response = await API.getBusinesses({
      ...(this.state.q.trim() ? { q: this.state.q.trim() } : {}),
      includeInactive: this.state.includeInactive,
    });

    this.setState({
      businesses: Array.isArray(response?.businesses) ? response.businesses : [],
      loading: false,
    });
  };

  openEditDialog = (selectedBusiness) => {
    this.setState({ editDialogOpen: true, selectedBusiness });
  };

  closeEditDialog = () => {
    this.setState({
      editDialogOpen: false,
      selectedBusiness: undefined,
      saving: false,
    });
  };

  handleSaveBusiness = async (business) => {
    this.setState({ saving: true });

    const response = await API.saveBusiness({ business });
    if (!response?.ok || !response?.business) {
      this.setState({ saving: false });
      global.showPopup("Hata", getErrorMessage(response));
      return;
    }

    await this.loadBusinesses();
    this.closeEditDialog();
  };

  handleDeleteBusiness = (business) => {
    global.openPrompt(
      "İşletmeyi sil",
      "Bu işlem işletmeyi siler ve bağlı kullanıcıları da devre dışı bırakır.",
      "Sil",
      async () => {
        this.setState({ saving: true });
        const response = await API.deleteBusiness({ _id: business._id });

        if (!response?.ok) {
          this.setState({ saving: false });
          global.showPopup("Hata", getErrorMessage(response));
          return;
        }

        await this.loadBusinesses();
        this.setState({ saving: false });
      }
    );
  };

  render() {
    const businesses = this.state.businesses;

    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 24,
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div>
            <Typography variant="h4" style={{ marginBottom: 8 }}>
              Businesses
            </Typography>
            <Typography style={{ color: "rgb(101, 116, 139)" }}>
              İşletmeleri ve bağlı kullanıcı sayılarını tek listeden yönetin.
            </Typography>
          </div>

          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Button variant="outlined" onClick={this.loadBusinesses}>
              Yenile
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => this.openEditDialog(undefined)}
            >
              Yeni İşletme
            </Button>
          </div>
        </div>

        <Badge style={{ padding: 0, overflow: "hidden" }}>
          <div
            style={{
              padding: 20,
              paddingLeft: 24,
              paddingRight: 24,
              borderBottom: "1px solid #E6E8F0",
            }}
          >
            <Typography variant="h6" style={{ marginBottom: 16 }}>
              İşletme Listesi
            </Typography>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(260px, 1.6fr) auto auto",
                gap: 12,
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                label="İşletme ara"
                value={this.state.q}
                onChange={(e) => this.setState({ q: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") this.loadBusinesses();
                }}
                placeholder="İşletme adı"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#94A3B8", fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
              />
              <FormControlLabel
                style={{ marginLeft: 0, marginRight: 0 }}
                control={
                  <Checkbox
                    checked={this.state.includeInactive}
                    onChange={(e) =>
                      this.setState(
                        { includeInactive: e.target.checked },
                        this.loadBusinesses
                      )
                    }
                  />
                }
                label="Pasifleri göster"
              />
              <Button
                variant="outlined"
                startIcon={<SearchIcon />}
                onClick={this.loadBusinesses}
              >
                Ara
              </Button>
            </div>
          </div>

          <div style={{ padding: "0 16px 16px 16px" }}>
            <DataGrid
              autoHeight
              getRowId={(row) => row._id}
              rows={businesses}
              loading={this.state.loading}
              disableRowSelectionOnClick
              initialState={{
                pagination: { paginationModel: { pageSize: 20, page: 0 } },
              }}
              pageSizeOptions={[20, 50, 100]}
              sx={{
                border: "none",
                "& .MuiDataGrid-cell": {
                  borderColor: "#EEF2F7",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#F8FAFC",
                  borderBottom: "1px solid #E7EDF6",
                },
              }}
              columns={[
                {
                  field: "name",
                  headerName: "İşletme",
                  flex: 1.4,
                  minWidth: 240,
                  renderCell: ({ row }) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography fontWeight={600}>{row.name}</Typography>
                      <Typography variant="body2" color="#64748B">
                        {API.getCityName(row.city) || "Şehir yok"}
                      </Typography>
                    </div>
                  ),
                },
                {
                  field: "userCount",
                  headerName: "Kullanıcı",
                  width: 120,
                  valueGetter: (_, row) => Number(row.userCount) || 0,
                },
                {
                  field: "activeUserCount",
                  headerName: "Aktif Kullanıcı",
                  width: 140,
                  valueGetter: (_, row) => Number(row.activeUserCount) || 0,
                },
                {
                  field: "status",
                  headerName: "Durum",
                  width: 130,
                  align: "center",
                  headerAlign: "center",
                  renderCell: ({ row }) => <StatusPill active={!row.deactive} />,
                },
                {
                  field: "detail",
                  headerName: "",
                  sortable: false,
                  filterable: false,
                  width: 72,
                  align: "center",
                  headerAlign: "center",
                  renderCell: ({ row }) => (
                    <Link
                      to={`/businesses/${row._id}`}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <IconButton size="small" sx={{ color: "#5654E8" }}>
                        <ArrowForwardIcon />
                      </IconButton>
                    </Link>
                  ),
                },
              ]}
            />
          </div>
        </Badge>

        <BusinessFormDialog
          open={this.state.editDialogOpen}
          business={this.state.selectedBusiness}
          saving={this.state.saving}
          onClose={this.closeEditDialog}
          onSubmit={this.handleSaveBusiness}
        />
      </div>
    );
  }
}

const StatusPill = ({ active }) => (
  <div
    style={{
      backgroundColor: active ? "rgba(22, 163, 74, 0.12)" : "rgba(220, 38, 38, 0.12)",
      color: active ? "#166534" : "#B91C1C",
      padding: "3px 10px",
      borderRadius: 999,
      fontWeight: 700,
      fontSize: 11,
      lineHeight: 1.2,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 24,
      whiteSpace: "nowrap",
    }}
  >
    {active ? "Aktif" : "Pasif"}
  </div>
);

const Badge = (props) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        border: "none",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.06)",
        borderRadius: 16,
        padding: 24,
        color: "#0B1C30",
        position: "relative",
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
